export default {"src":"/_next/static/media/4prothesis.53a004d6.svg","height":45,"width":35,"blurWidth":0,"blurHeight":0};